module.exports = {
	"header": "Meet Spotin at Bits & Pretzels",
	"date": "2022/09/14",
	"imgSrc": "bits_pretzels_news_image.png",
	"imgAlt": "Bits & Pretzels Conference 2022",
	"ingress": "Spotin will be at the Bits & Pretzels event in Germany (Munich) from 25th-27th of September. We are looking forward to meeting investors and seeking strategic partnerships for business expansion in Europe and US with brands and publishers.",
	"sections": [
		{
			"paragraphs": [
				"Spotin enables friction-free commerce from within any 3rd-party website, app, or platform - without links or re-directions.",
				"We are participating on all days of the event (25th-27th September) and will be exhibiting at booth no. ST46 in the Commerce & Marketplaces cluster on Monday 26th. If you are interested to learn more about Spotin, please come by our booth or book a meeting with us in the event app. If you are not able to visit us there, feel free to drop us an email at <a href='mailto:marketing@spotin.com'>marketing@spotin.com</a> and we will get back to you."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/9/article.json
// module id = 22
// module chunks = 0